import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, APP_INITIALIZER } from '@angular/core';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { DashboardModule } from './components/dashboard/dashboard.module';
import { SharedModule } from './shared/shared.module';
import { ProductsModule } from './components/products/products.module';
import { SalesModule } from './components/sales/sales.module';
import { CouponsModule } from './components/coupons/coupons.module';
import { PagesModule } from './components/pages/pages.module';
import { MediaModule } from './components/media/media.module';
import { MenusModule } from './components/menus/menus.module';
import { VendorsModule } from './components/vendors/vendors.module';
import { UsersModule } from './components/users/users.module';
import { LocalizationModule } from './components/localization/localization.module';
import { InvoiceModule } from './components/invoice/invoice.module';
import { SettingModule } from './components/setting/setting.module';;
import { ReportsModule } from './components/reports/reports.module';
import { AuthModule } from './components/auth/auth.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './components/interceptors/auth.interceptor';
import { DataTablesModule } from 'angular-datatables';
import { ClientsModule } from './components/clients/clients.module';
import { AgmCoreModule } from '@agm/core';
import { QuizsModule } from './components/quizs/quizs.module';
import { SurveysModule } from './components/surveys/surveys.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { environment } from 'src/environments/environment';
import { ThemeService } from './shared/service/theme.service';
import { CatalogsModule } from './components/catalogs/catalogs.module';
import { TripsModule } from './components/trips/trips.module';
import { Dashboardv2Module } from './components/dashboardv2/dashboardv2.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatChipsModule } from '@angular/material/chips';
import { ToastrModule } from 'ngx-toastr';

export function initTheme(theme: ThemeService) {
  return () => theme.apply();
}

const API: string = environment.API_KEY;
@NgModule({
  declarations: [
    AppComponent,

  ],
  imports: [
    ToastrModule.forRoot({
      timeOut: 3500,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    MatChipsModule,
    MatTableModule,
    MatTabsModule,
    BrowserAnimationsModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    DashboardModule,
    Dashboardv2Module,
    InvoiceModule,
    SettingModule,
    ReportsModule,
    CatalogsModule,
    TripsModule,
    AuthModule,
    SharedModule,
    LocalizationModule,
    ProductsModule,
    SalesModule,
    VendorsModule,
    CouponsModule,
    PagesModule,
    MediaModule,
    MenusModule,
    UsersModule,
    ClientsModule,
    DataTablesModule,
    QuizsModule,
    SurveysModule,
    NgMultiSelectDropDownModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: API,
      libraries: ['places', 'geometry', 'drawing', 'visualization']
    }),
  ],
  providers: [
    AppComponent,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptor,
          multi: true
        },
        {
          provide: APP_INITIALIZER,
          useFactory: initTheme,
          deps: [ThemeService],
          multi: true
        }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
